import React from 'react';
import styles from './styles.scss';
import { Col, Row, Container } from '../../components/Grid';
import Icon from 'Components/Icon';

export const FormErrorModal = ({ dealer }) => {
  const whatsappUrl = dealer.settings.whatsappWidget.whatsappUrl;
  const phone = dealer.dealerLocations[0].phone;
  const email = dealer.dealerLocations[0].email;
  return (
    <Container>
      <Row>
        <Col cols={12}>
          <h2 className={styles.deactivatedHeadline}>Fehler beim Absenden</h2>
        </Col>

        <Col cols={12} className={styles.deactivatedText}>
          <p>
            Ihre Anfrage kann leider im Moment nicht übermittelt werden. Wir arbeiten gerade an der
            Ursache.
          </p>
          <p>
            Versuchen Sie es zu einem späteren Zeitpunkt bitte noch einmal oder kontaktieren Sie uns
            direkt:
          </p>
        </Col>

        <Col cols={12}>
          <div className={styles.deactivatedMessageSeparationLine}></div>
        </Col>

        <Col cols={12}>
          <ul className={styles.deactivatedAddress}>
            <li className={styles.deativatedContactRow}>
              <h2 className={styles.dealerName}>{dealer.name}</h2>
            </li>
            <li className={styles.deativatedContactRow}>
              <span className={styles.iconWrapper}>
                <Icon name="phone" />
              </span>

              <div className={styles.deativatedContactText}>
                <a href={`tel:${phone}`}>{phone}</a>
              </div>
            </li>
            <li className={styles.deativatedContactRow}>
              <span className={styles.iconWrapper}>
                <Icon name="mail" />
              </span>

              <div className={styles.deativatedContactText}>
                <a href={`mailto:${email}`}>{email}</a>
              </div>
            </li>

            {whatsappUrl && (
              <li className={styles.deativatedContactRow}>
                <span className={styles.iconWrapper}>
                  <img
                    alt=""
                    className={styles.whatsappIcon}
                    src={`${process.env.ASSET_ENV_HOST}/assets/img/icon_whatsapp_green.svg`}
                  />
                </span>

                <div className={styles.deativatedContactText}>
                  <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                    WhatsApp Chat starten
                  </a>
                </div>
              </li>
            )}
          </ul>
        </Col>
      </Row>
    </Container>
  );
};
